import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useSelector, useDispatch } from 'react-redux';

import { getPins } from '../../../services/documentsService';

import { RootState } from '../../../../redux/store';
import { PIN, POPUP, } from '../../../../redux/types';

import { IDocPinSection } from '../../types/IDocPinSection';

import CardsGrid from './cardsGrid/cardsGrid';

import './docPinSection.scss';

const DocPinSection: React.FC<IDocPinSection> = () => {
  const [pins, setPins] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const pin = useSelector((state: RootState) => state.pin.pin);
  const impersonate = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setLoading(true);
    getPins().then((r) => {
      setLoading(false);
      setPins(r.data);
      dispatch({ type: PIN.SET_PINS, value: r.data });
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, [pin, impersonate]);

  return (
    <>
      {pins.length > 0 ? (
        <div className='doc-pin-wrapper section'>
          <p className='section-title'>{t('HOME.PINS.SECTION_TITLE')}</p>
          <CardsGrid pins={pins} loading={loading} />
        </div>
      ) : null}
    </>
  );
};

export default DocPinSection;
